import { Controller } from '@hotwired/stimulus'

// Shows one panel per checked radio value. Each panel needs data-when="<radio value>".
//
// data-controller="split-mode-panels"
// <input type="radio" data-split-mode-panels-target="radio" data-action="split-mode-panels#reveal">
// <div data-split-mode-panels-target="panel" data-when="number_of_lists">...</div>

export default class extends Controller {
  static targets = ['radio', 'panel']

  connect() {
    this.reveal()
  }

  reveal() {
    const checked = this.radioTargets.find((el) => el.checked)
    const value = checked ? checked.value : null
    this.panelTargets.forEach((panel) => {
      const when = panel.dataset.when
      panel.classList.toggle('d-none', when !== value)
    })
  }
}
